export const CART_ERROR_KEYS = {
  MISSING_ORDER_DRAFT: 'checkout-could-not-be-initialized',
  ERX_SERVICE_UNAVAILABLE: 'checkout-error-erx-service-unavailable',
  CUSTOMER_TYPE_PROFESSIONAL_HAS_MEDICINE_PRODUCT:
    'checkout-error-customer-type-professional-has-medicine-product',
  CUSTOMER_TYPE_PROFESSIONAL_HAS_MARKETPLACE_PRODUCT:
    'checkout-error-customer-type-professional-has-marketplace-product',
  CUSTOMER_TYPE_PROFESSIONAL_HAS_MEDICINE_AND_MARKETPLACE_PRODUCT:
    'checkout-error-customer-type-professional-has-medicine-and-marketplace-product',
  REDPOINTS_RESERVATION_FAILED: 'redpoints-reservation-failed',
}
